export default "__VITE_ASSET__DIr2yrnh__"